/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Ctatitle1Inputs */

const he_extension_ctatitle1 = /** @type {(inputs: Extension_Ctatitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוכנים להתחיל לחסוך?`)
};

const en_extension_ctatitle1 = /** @type {(inputs: Extension_Ctatitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to Start Saving?`)
};

/**
* | output |
* | --- |
* | "Ready to Start Saving?" |
*
* @param {Extension_Ctatitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_ctatitle1 = /** @type {((inputs?: Extension_Ctatitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Ctatitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_ctatitle1(inputs)
	return en_extension_ctatitle1(inputs)
});
export { extension_ctatitle1 as "extension_ctaTitle" }